import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CTABand = ({ testid = "cta-band" }) => (
  <section data-testid={testid} className="border-t border-line bg-surface py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
        <div>
          <h2 className="font-display text-2xl font-bold tracking-tight text-charcoal-900 sm:text-3xl lg:text-4xl">
            Let's build together.
          </h2>
          <p className="mt-3 max-w-xl text-base leading-relaxed text-steel">
            Boston's next big platform starts with a conversation with investors, venues,
            promoters, brands, and campus organizations.
          </p>
        </div>
        <Link
          to="/contact"
          data-testid={`${testid}-button`}
          className="group inline-flex shrink-0 items-center gap-2 bg-accent px-8 py-4 font-mono text-xs font-semibold uppercase tracking-[0.15em] text-white transition-colors duration-200 hover:bg-accent-dark"
        >
          Contact Us
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default CTABand;
